module.exports = __webpack_public_path__ + "static/media/3.51fc5160.svg";